/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type CancelPolicyDto = {
    /**
     * Cancellation reason mapped to Ando mta_reason
     */
    reason: CancelPolicyDto.reason;
    /**
     * Additional cancellation context mapped to Ando mta_reason_description
     */
    reasonDetails: string;
    /**
     * Effective cancellation date mapped to Ando mta_effective_date
     */
    effectiveCancellationDate: string;
    /**
     * Frontend-only calculation hint retained for audit metadata
     */
    calculationMethod?: CancelPolicyDto.calculationMethod;
    /**
     * Administration fee applied to settlement
     */
    adminFee: number;
    /**
     * Broker fee applied to settlement
     */
    brokerFee: number;
    /**
     * Insurer cancellation fee applied to settlement
     */
    insurerCancellationFee: number;
    /**
     * Commission clawback applied to settlement
     */
    commissionClawback: number;
    /**
     * When true, refunds the admin/broker fees originally charged on the policy in addition to the premium settlement
     */
    refundAdminFees?: boolean;
    /**
     * Optional adviser notes for cancellation
     */
    notes?: string;
};
export namespace CancelPolicyDto {
    /**
     * Cancellation reason mapped to Ando mta_reason
     */
    export enum reason {
        POLICY_CANCELLED_BROKER_LOST_ACCOUNT = 'POLICY CANCELLED - BROKER LOST ACCOUNT',
        POLICY_CANCELLED_CANCELLED_BY_ANDO = 'POLICY CANCELLED - CANCELLED BY ANDO',
        POLICY_CANCELLED_FREE_LOOK = 'POLICY CANCELLED - FREE-LOOK',
        POLICY_CANCELLED_INSURED_ELSEWHERE = 'POLICY CANCELLED - INSURED ELSEWHERE',
        POLICY_CANCELLED_ISSUED_IN_ERROR = 'POLICY CANCELLED - ISSUED IN ERROR',
        POLICY_CANCELLED_NON_PAYMENT_OF_PREMIUM = 'POLICY CANCELLED - NON-PAYMENT OF PREMIUM',
        POLICY_CANCELLED_NOT_HAPPY_WITH_SERVICE = 'POLICY CANCELLED - NOT HAPPY WITH SERVICE',
        POLICY_CANCELLED_NOT_REQUIRED = 'POLICY CANCELLED - NOT REQUIRED',
        POLICY_CANCELLED_REASON_UNKNOWN = 'POLICY CANCELLED - REASON UNKNOWN',
        POLICY_CANCELLED_REPLACED = 'POLICY CANCELLED - REPLACED',
        POLICY_CANCELLED_SOLD = 'POLICY CANCELLED - SOLD',
        POLICY_CANCELLED_TOTAL_LOSS = 'POLICY CANCELLED - TOTAL LOSS',
    }
    /**
     * Frontend-only calculation hint retained for audit metadata
     */
    export enum calculationMethod {
        PRO_RATA = 'pro-rata',
        SHORT_RATE = 'short-rate',
    }
}

